import React from 'react'
import BreadCrumbs from '../components/BreadCrumbs'

const AddCard = () => {
    return (
        <>

            <BreadCrumbs title1={'Home'} title2={'Dashboard'} title3={'Add Payment Method'} />

            {/* <!-- ======================= Dashboard Detail ======================== --> */}
            <section className="middle">
                <div className="container">
                    <div className="row align-items-start justify-content-between">

                        <div className="col-12 col-md-12 col-lg-4 col-xl-4 text-center miliods">
                            <div className="d-block border rounded mfliud-bot">
                                <div className="dashboard_author px-2 py-5">
                                    <div className="dash_auth_thumb circle p-1 border d-inline-flex mx-auto mb-2">
                                        <img src="assets/img/team-1.jpg" className="img-fluid circle" width="100" alt="" />
                                    </div>
                                    <div className="dash_caption">
                                        <h4 className="fs-md ft-medium mb-0 lh-1">Adam Wishnoi</h4>
                                        <span className="text-muted smalls">Australia</span>
                                    </div>
                                </div>

                                <div className="dashboard_author">
                                    <h4 className="px-3 py-2 mb-0 lh-2 gray fs-sm ft-medium text-muted text-uppercase text-left">Dashboard Navigation</h4>
                                    <ul className="dahs_navbar">
                                        <li><a href="my-orders.html"><i className="lni lni-shopping-basket mr-2"></i>My Order</a></li>
                                        <li><a href="wishlist.html"><i className="lni lni-heart mr-2"></i>Wishlist</a></li>
                                        <li><a href="profile-info.html"><i className="lni lni-user mr-2"></i>Profile Info</a></li>
                                        <li><a href="addresses.html"><i className="lni lni-map-marker mr-2"></i>Addresses</a></li>
                                        <li><a href="payment-methode.html" className="active"><i className="lni lni-mastercard mr-2"></i>Payment Methode</a></li>
                                        <li><a href="login.html"><i className="lni lni-power-switch mr-2"></i>Log Out</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 col-md-12 col-lg-8 col-xl-8">
                            {/* <!-- row --> */}
                            <form className="row">

                                <div className="col-12 col-lg-12 col-xl-12 col-md-12 mb-3">
                                    <h4 className="ft-medium fs-lg">Add Debit / Credit Card</h4>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <label className="text-dark">Card Holder Name *</label>
                                        <input type="text" className="form-control" placeholder="Dhananjay Preet" />
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group">
                                        <label className="text-dark">Card Number *</label>
                                        <input type="text" className="form-control" placeholder="5426 4586 5485 4759" />
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-5 col-sm-6">
                                    <div className="form-group">
                                        <label className="text-dark">Expire Month *</label>
                                        <select className="custom-select">
                                            <option value="1" selected="">January</option>
                                            <option value="2">February</option>
                                            <option value="3">March</option>
                                            <option value="4">April</option>
                                            <option value="5">May</option>
                                            <option value="6">June</option>
                                            <option value="7">July</option>
                                            <option value="8">August</option>
                                            <option value="9">September</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-lg-5 col-md-5 col-sm-6">
                                    <div className="form-group">
                                        <label className="text-dark">Expire Year *</label>
                                        <select className="custom-select">
                                            <option value="1" selected="">2010</option>
                                            <option value="2">2018</option>
                                            <option value="3">2019</option>
                                            <option value="4">2020</option>
                                            <option value="5">2021</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-lg-2 col-md-2 col-sm-12">
                                    <div className="form-group">
                                        <label className="text-dark">CVC *</label>
                                        <input type="text" className="form-control" placeholder="CVV*" />
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="form-group">
                                        <input id="ak-2" className="checkbox-custom" name="ak-2" type="checkbox" />
                                        <label for="ak-2" className="checkbox-custom-label">By Continuing, you ar'e agree to conditions</label>
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-group text-center">
                                        <a href="add-card.html#" className="btn btn-dark full-width">Add & Save card</a>
                                    </div>
                                </div>

                            </form>
                            {/* <!-- row --> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* <!-- ======================= Dashboard Detail End ======================== --> */}



        </>
    )
}

export default AddCard